// Shared Tailwind class constants for the auth flow wrappers (Login and ForgotPassword).
// The three challenges in Login and the three phases in ForgotPassword all share the same
// page background, card shell, and logo size — keeping them in one place ensures they
// stay in sync.

/** Full-viewport wrapper: light-violet brand gradient in light mode, slate-900 in dark. */
export const authPageWrapper =
  'min-h-screen flex items-center justify-center bg-login-hero dark:bg-none dark:bg-slate-900 py-12 px-4 sm:px-6 lg:px-8';

/** Auth card: elevated white panel with login-card shadow in light mode; dark uses soft-lg. */
export const authCard =
  'max-w-md w-full rounded-xl border border-slate-200/80 bg-white px-9 py-10 shadow-login-card dark:bg-slate-800 dark:border-slate-700 dark:shadow-soft-lg-dark';

/** Logo height — 84px per brand spec (slightly smaller than h-24/96px for visual balance). */
export const authLogoClass = 'h-[84px] mx-auto mb-4';
